module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.display),
      expression: "display"
    }],
    staticClass: "messageview"
  }, [_c('p', {
    class: {
      danger: _vm.isError, warning: _vm.isWarning, success: _vm.isSuccess
    }
  }, [_c('ul', _vm._l((_vm.messages), function(msg) {
    return _c('li', [_vm._v(_vm._s(msg))])
  })), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.messageConfig.autoClose),
      expression: "!messageConfig.autoClose"
    }],
    attrs: {
      "href": "javascript:void"
    },
    on: {
      "click": function($event) {
        _vm.messageClose()
      }
    }
  }, [_vm._v(_vm._s(_vm.messageConfig.closeCaption))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3923fb72","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageView.vue
// module id = 595
// module chunks = 1